<template>
  <div>
    <Table :columns="columns" :data="resources" size="small">
      <template slot-scope="{ row }" slot="account_number">
        {{ row.account ? row.account.account_number : '' }}
      </template>
      <template slot-scope="{ row }" slot="account_name">
        {{ row.account ? row.account.account_name_en : '' }}
        {{
          row.account.account_name_kh ? '|' + row.account.account_name_kh : ''
        }}
      </template>
      <template slot-scope="{ row }" slot="debit_amount">
        <ts-display-currency
          :amount="row.debit_amount"
          :currency_id="row.currency_id"
        />
      </template>
      <template slot-scope="{ row }" slot="credit_amount">
        <ts-display-currency
          :amount="row.credit_amount"
          :currency_id="row.currency_id"
        />
      </template>
    </Table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { orderBy } from 'lodash'
export default {
  props: {
    row: Object
  },
  computed: {
    ...mapGetters(['formatCurrencyWithCode']),
    resources() {
      return orderBy(this.row.details, ['display_order'])
    },
    currency() {
      return this.row.currency
    },
    columns() {
      return [
        {
          title: this.$t('journalEntry.accountNumber'),
          key: 'account_number',
          slot: 'account_number',
          sortable: true,
          width: 200
        },
        {
          title: this.$t('journalEntry.accountName'),
          key: 'account_name',
          slot: 'account_name',
          sortable: true,
          width: 350
        },
        {
          title: this.$t('journalEntry.debitAmount'),
          slot: 'debit_amount',
          sortable: true,
          width: 250,
          align: 'right'
        },
        {
          title: this.$t('journalEntry.creditAmount'),
          slot: 'credit_amount',
          sortable: true,
          width: 250,
          align: 'right'
        },
        {
          title: this.$t('journalEntry.remarks'),
          key: 'remarks'
        }
      ]
    }
  },
  methods: {}
}
</script>
